import * as React from 'react';

import './SaleReportConversationComposer.scss';
import SaleReportComment from "./SaleReportComment.js";

export default function SaleReportCommentComposer({ saleReport, onSubmit }) {
	const [isReady, setIsReady] = React.useState(false);
	const [isProcessing, setIsProcessing] = React.useState(false);
	const textareaRef = React.useRef(undefined);

	const submit = async () => {
		if (!isReady) {
			return;
		}
		const textarea = textareaRef.current;

		const comment = new SaleReportComment();
		comment.message = textarea.value.trim();
		comment.sale_report = saleReport.id;

		setIsProcessing(true);
		await comment.save();
		setIsProcessing(false);

		textarea.value = '';
		textarea.focus();
		setIsReady(false);

		onSubmit?.();
	};
	const handleKeyUp = e => {
		if (e.keyCode === 13 && !e.shiftKey && !e.metaKey) {
			e.target.value = e.target.value.trim();
			submit();
			return;
		}
		setIsReady(!!e.target.value);
	};

	if (!saleReport.id) {
		return (<></>);
	}

	return (
		<div className={["sale-report-comment-composer", isReady && ' is-ready', isProcessing && "is-processing"].filter(f=>f).join(" ")}>
			<textarea ref={textareaRef} placeholder="Your Message" className="sale-report-comment-composer-textarea" onKeyUp={handleKeyUp} />
			<button onClick={submit}>Send</button>
		</div>
	);
}